import React from "react";
import PropTypes from "prop-types";
import FincludeLogo from "../../../assets/images/finclude.png";
import { Field, Form } from "react-final-form";
import ValidatedInput from "../../common/ValidatedInput";
import { Link } from "react-router-dom";

const ForgotPasswordForm = ({ onSubmit, successMessage }) => {
  return (
    <Form
      onSubmit={onSubmit}
      render={({
        submitError,
        handleSubmit,
        form,
        submitting,
        pristine,
        values,
      }) => (
        <form className="box mw-400 p-sm-5" onSubmit={handleSubmit}>
          <img
            className="d-block mx-auto mb-4"
            src={FincludeLogo}
            alt="Finclude"
          />
          <h5 className="text-center mb-3">Password reset</h5>
          {submitError ? (
            <p className="text-center text-error">{submitError} </p>
          ) : (
            <p className="text-center text-success">{successMessage} </p>
          )}
          <p className="text-center">
            Enter your email and follow the instructions to reset your email.
          </p>
          <div className="fin-col mb-2">
            <div className="field-wrap mb-2 field-error">
              <Field
                inputClassName="fin-control mb-2"
                type="email"
                component={ValidatedInput}
                placeholder="Email"
                name="email"
              />
            </div>
          </div>

          <button
            className="btn btn-main d-block w-100 mt-3"
            id="submit"
            disabled={submitting || pristine}
          >
            Reset password
          </button>
          <p className="text-small text-center mt-45">
            Back to{" "}
            <Link className="d-inline-block link-color" to="/login">
              Login
            </Link>
          </p>
        </form>
      )}
    />
  );
};

ForgotPasswordForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  successMessage: PropTypes.string,
};

export default ForgotPasswordForm;
